import React from 'react';
import { LoginEmailPageSection } from '@zep/auth';
export const SigninConfirmPageView = () => {
  return <LoginEmailPageSection data-sentry-element="LoginEmailPageSection" data-sentry-component="SigninConfirmPageView" data-sentry-source-file="confirm.tsx" />;
};